import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactComponent as CommingSoonIcon } from '../../../images/icons/coming_soon_Icon.svg';
import { darkPurple, dimGrey } from '../../../mainTheme';

const ComingSoonCard = () => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box sx={{ mb: '24px', mt: '24px' }}>
        <CommingSoonIcon />
      </Box>
      <Typography
        gutterBottom
        sx={{
          color: darkPurple,
          fontSize: '18px',
          fontWeight: 500,
          lineHeight: '24px',
          letterSpacing: '0.2px',
        }}
      >
        Coming soon
      </Typography>
      <Typography
        sx={{
          color: dimGrey,
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '20px',
          letterSpacing: '0.2px',
        }}
        mb={2}
      >
        This feature is currently under development and will be available soon.
      </Typography>
    </Box>
  );
};

export default ComingSoonCard;
